import { render, staticRenderFns } from "./DelegationTerritoriale.vue?vue&type=template&id=6138e813"
import script from "./DelegationTerritoriale.vue?vue&type=script&lang=js"
export * from "./DelegationTerritoriale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports